import { render } from "./CameraTemplate.vue?vue&type=template&id=3be33349&scoped=true"
import script from "./CameraTemplate.vue?vue&type=script&lang=js"
export * from "./CameraTemplate.vue?vue&type=script&lang=js"

import "./CameraTemplate.vue?vue&type=style&index=0&id=3be33349&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be33349"]])

export default __exports__